import { useState, useEffect } from "react";
import {
  subscribeToAgreementTemplates,
  subscribeToPartnerAgreements,
  addAgreementTemplate,
  updateAgreementTemplate,
  deleteAgreementTemplate,
  addPartnerAgreement,
  updatePartnerAgreement,
  deletePartnerAgreement,
  seedDefaultAgreementTemplates
} from "../services/agreementsService";

export function useAgreements() {
  const [templates, setTemplates] = useState([]);
  const [agreements, setAgreements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Attempt auto-seed if templates collection is empty
    seedDefaultAgreementTemplates();

    let unsubTemplates = null;
    let unsubAgreements = null;

    try {
      unsubTemplates = subscribeToAgreementTemplates((items, err) => {
        if (err) {
          setError(err);
        } else {
          setTemplates(items);
        }
      });

      unsubAgreements = subscribeToPartnerAgreements((items, err) => {
        if (err) {
          setError(err);
        } else {
          setAgreements(items);
        }
        setLoading(false);
      });
    } catch (err) {
      console.error("Error in useAgreements:", err);
      setError(err);
      setLoading(false);
    }

    return () => {
      if (unsubTemplates) unsubTemplates();
      if (unsubAgreements) unsubAgreements();
    };
  }, []);

  return {
    templates,
    agreements,
    loading,
    error,
    addTemplate: addAgreementTemplate,
    updateTemplate: updateAgreementTemplate,
    deleteTemplate: deleteAgreementTemplate,
    addAgreement: addPartnerAgreement,
    updateAgreement: updatePartnerAgreement,
    deleteAgreement: deletePartnerAgreement
  };
}
